import styled from "styled-components";
import { motion } from "framer-motion";

// Floating centered nav bar. The objective uses a rounded capsule; the design
// contract forbids radius, so it renders as a square black slab with a hard
// bevel — dell-1996's `top-banner` treatment scaled down (DESIGN.md:502-503).

export const Nav = styled.nav`
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 900;
  display: flex;
  justify-content: center;
  padding: 0 12px;
  pointer-events: none;

  @media (max-width: 768px) {
    top: 12px;
  }
`;

export const NavBar = styled(motion.div)`
  position: relative;
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px;

  background: ${({ theme }) => theme.frameInk};
  border: 1px solid ${({ theme }) => theme.orange};
  border-radius: 0;
  box-shadow: ${({ theme }) => theme.bevel} rgba(0, 0, 0, 0.55);
`;

// Reading-progress rule pinned under the nav. Scales on the X axis only, so it
// composites without layout work.
export const Progress = styled(motion.div)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  transform-origin: 0 50%;
  background: ${({ theme }) => theme.orange};
`;

export const NavLink = styled.a`
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  text-decoration: none;
  border-radius: 0;

  font-family: ${({ theme }) => theme.fonts.ui};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  white-space: nowrap;

  color: ${({ $active, theme }) => ($active ? theme.frameInk : "#ffffff")};
  background: ${({ $active, theme }) =>
    $active ? theme.orange : "transparent"};
  transition: background 120ms linear, color 120ms linear;

  &:hover {
    color: ${({ $active, theme }) => ($active ? theme.frameInk : theme.orange)};
    background: ${({ $active, theme }) =>
      $active ? theme.orange : "rgba(255, 130, 54, 0.14)"};
  }

  @media (max-width: 560px) {
    padding: 9px 10px;
    font-size: 11px;
    letter-spacing: 0.8px;
  }
`;
